export const baseURL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BE_BASE_URL || 'https://staging-be.exportstuff.com';

// LogIn SignUp
export const login = "/api/v1/users/sign_in";
export const signIn = "/api/v1/users";

// Products
export const products = "/api/v1/products";

// Units
export const units = "/api/v1/units";

// Countries
export const countries = "/api/v1/countries";

// container_types
export const containerTypes = "/api/v1/container_types";

// States by id
export const states = "/api/v1/states";

// currencies
export const currencies = "/api/v1/currencies";

//Package Type
export const packageTypes = "/api/v1/package_types";

//city
export const city = "/api/v1/cities";

//quotations
export const quotations = "/api/v1/quotations";
//proforma invoices
export const performa_invoices = "/api/v1/proforma_invoices";

//invoices
export const invoices = "/api/v1/invoices";

//bl_drafts
export const bl_drafts = "/api/v1/bl_drafts";

// package listings
export const package_listings = "/api/v1/package_listings";

//Payment terms
export const paymentTerms = "/api/v1/payment_terms";

//ports
export const ports = "/api/v1/ports";

//customers
export const customers = "/api/v1/customers";
// banks
export const banks = "/api/v1/banks";
// employees
export const employees = "/api/v1/employees";

// subscriptions
export const subscription = "/api/v1/subscriptions/current";
export const applyCoupon = "/api/v1/subscriptions/apply_coupon";
export const upgradeSubscription = "/api/v1/subscriptions/upgrade";
export const checkLimit = "/api/v1/subscriptions/check_limit";

// quotation documents
export const quotation_documents = "/api/v1/quotation_documents";

// performa documents
export const performa_documents = "/api/v1/performa_documents";

// invoice documents
export const invoice_documents = "/api/v1/invoice_documents";

// bl draft documents
export const bl_draft_documents = "/api/v1/bl_draft_documents";

// package listing documents
export const package_listing_documents = "/api/v1/package_listing_documents";

// vgm documents
export const vgm_documents = "/api/v1/vgm_documents";

// annexure documents
export const annexure_documents = "/api/v1/annexure_documents";

// organizations
export const organizations = "/api/v1/organizations/current";

// SaaS Subscriptions & Billing
export const subscriptions_current = "/api/v1/subscriptions/current";
export const subscriptions_history = "/api/v1/subscriptions/history";
export const subscriptions_usage_history = "/api/v1/subscriptions/usage_history";
export const subscriptions_upgrade = "/api/v1/subscriptions/upgrade";
export const subscriptions_create_razorpay_order = "/api/v1/subscriptions/create_razorpay_order";
export const subscriptions_verify_razorpay_payment = "/api/v1/subscriptions/verify_razorpay_payment";
export const subscription_plans = "/api/v1/subscription_plans";
export const saas_invoices = "/api/v1/saas_invoices";

// document number settings
export const document_number_settings = "/api/v1/document_number_settings";
